/**
 * Contains hardcoded list of levels available when rendering the dropdown.
 */
export const levels = {
    primarySchool: [
        "0. klasse",
        "1. klasse",
        "2. klasse",
        "3. klasse",
        "4. klasse",
        "5. klasse",
        "6. klasse",
        "7. klasse",
        "8. klasse",
        "9. klasse",
        "10. klasse",
    ],
    highSchool: [
        "Grundforløb",
        "C niveau",
        "B niveau",
        "A niveau",
        "Ingen niveau",
    ],
};
